import { render, staticRenderFns } from "./SplitText.vue?vue&type=template&id=da09abcc&lang=pug&"
import script from "./SplitText.vue?vue&type=script&lang=js&"
export * from "./SplitText.vue?vue&type=script&lang=js&"
import style0 from "./SplitText.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SplitText.vue"
export default component.exports